export const EMAIL_SUPPORT = 'support@ads.wp.pl'
export const EMAIL_SALES = 'sales@ads.wp.pl'
export const WP_OFFER_LINK = 'https://reklama.wp.pl/oferta'
export const WP_OFFER_CONTACT = 'https://reklama.wp.pl/kontakt'
